/**
 * Shared motion tokens.
 *
 * Every duration/easing used by a framer-motion component comes from here so
 * the whole product shares one rhythm, matching the CSS tokens in tokens.css.
 * Exit transitions run at ~65% of enter, which reads as more responsive.
 */

export const EASE_OUT = [0.16, 1, 0.3, 1];
export const EASE_IN_OUT = [0.83, 0, 0.17, 1];

export const DUR = {
  press: 0.11,
  state: 0.2,
  enter: 0.32,
  reveal: 0.54,
  page: 0.62,
  exit: 0.2,
};

export const SPRING = {
  /** Cursor ring: loose and trailing. */
  cursorRing: { stiffness: 320, damping: 26, mass: 0.55 },
  /** Cursor dot: tight, near-instant. */
  cursorDot: { stiffness: 1100, damping: 45, mass: 0.35 },
  /** Magnetic pull on focal buttons. */
  magnet: { stiffness: 220, damping: 18, mass: 0.5 },
  /** Number counters and gauge arcs. */
  readout: { stiffness: 70, damping: 18, mass: 0.9 },
  /** Nav pill sliding between routes. */
  pill: { stiffness: 420, damping: 34, mass: 0.7 },
};

/** Section-level reveal: a short fade with a small lift, so it reads as a fade. */
export const revealVariants = {
  hidden: { opacity: 0, y: 18 },
  shown: {
    opacity: 1,
    y: 0,
    transition: { duration: DUR.reveal, ease: EASE_OUT },
  },
};

/** Parent of a staggered group. Children use `revealVariants`. */
export const groupVariants = {
  hidden: {},
  shown: {
    transition: { staggerChildren: 0.042, delayChildren: 0.04 },
  },
};

/** Reduced-motion equivalents: final state, no travel. */
export const staticVariants = {
  hidden: { opacity: 1, y: 0 },
  shown: { opacity: 1, y: 0, transition: { duration: 0 } },
};

/** Route transition. Forward motion enters from below, per `hierarchy-motion`. */
export const pageVariants = {
  initial: { opacity: 0, y: 14 },
  enter: { opacity: 1, y: 0, transition: { duration: DUR.page * 0.6, ease: EASE_OUT } },
  exit: { opacity: 0, y: -8, transition: { duration: DUR.exit, ease: EASE_OUT } },
};

export const staticPageVariants = {
  initial: { opacity: 1 },
  enter: { opacity: 1, transition: { duration: 0 } },
  exit: { opacity: 1, transition: { duration: 0 } },
};

/** Standard viewport config for scroll reveals: fire once, slightly early. */
export const VIEWPORT = { once: true, margin: "0px 0px -12% 0px" };
